module.exports = __webpack_public_path__ + "img/gc_country_flag_no.5c7db33f.svg";